import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { ListStatusModule } from '../../../shared/component/common/list-status/list-status.module';
import { OverviewUserDataComponent } from './overview-user-data.component';
import { LoadingCircleModule } from '../../../shared/component/common/loading-circle/loading-circle.module';
import { CaronteCustodiaService } from '../../../shared/service/caronte-custodia/caronte-custodia.service';
import { environment } from 'src/environments/environment';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    ListStatusModule,
    LoadingCircleModule,
  ],
  declarations: [OverviewUserDataComponent]
})
export class OverviewUserDataModule {}
